
import React from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { Container } from "@/components/ui/container";

const Terms = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <main className="flex-grow py-10">
        <Container>
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          
          <div className="prose prose-slate dark:prose-invert max-w-none">
            <p className="mb-4">Last Updated: May 4, 2025</p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using TeenVisor's website and services, you agree to be bound by these Terms of Service and all applicable laws and regulations.
              If you do not agree with any of these terms, you are prohibited from using or accessing this site.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. Use of Services</h2>
            <p>
              Our services are intended for individuals seeking mentorship, career guidance, and educational resources. You agree to use our services only for lawful purposes and in a way that does not infringe upon the rights of others or restrict their use of the services.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. User Accounts</h2>
            <p>
              When you create an account with us, you are responsible for maintaining the confidentiality of your account information and password. You are responsible for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Content and Conduct</h2>
            <p>Users of our platform agree not to post content that:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Is unlawful, harmful, threatening, abusive, harassing, defamatory, or invasive of another's privacy</li>
              <li>Infringes any patent, trademark, trade secret, copyright, or other intellectual property rights</li>
              <li>Contains software viruses or any other computer code designed to disrupt functionality</li>
              <li>Impersonates any person or entity or falsely states or misrepresents your affiliation with a person or entity</li>
            </ul>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Intellectual Property</h2>
            <p>
              The content on our platform, including text, graphics, logos, and software, is owned by TeenVisor or its content suppliers and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from this content without explicit permission.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">6. Mentorship Relationships</h2>
            <p>
              TeenVisor provides a platform for connecting mentors with mentees, but we are not responsible for the actions, content, information, or data of third parties. We do not guarantee the quality, safety, or legality of mentorship provided through our platform.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">7. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by applicable law, TeenVisor shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your access to or use of, or inability to access or use, the services or any content provided on or through the services.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">8. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account and access to our services at our sole discretion, without notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties, or for any other reason.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">9. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will provide notice of any significant changes by posting the new Terms of Service on this site and updating the "Last Updated" date.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">10. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
              <br />
              <a href="mailto:teenvisor@gmail.com" className="text-primary hover:underline">teenvisor@gmail.com</a>
            </p>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
